
import React, { useEffect, useState } from 'react';
import TermsCheckbox from './TermAndCondition';
import CommonDialog from 'components_newui/dialogs/CommonDialog';

export const ShowPopupFirstTime = (props)=>{
    // console.log("ShowPopupFirstTime props",props)
    const {dialogOpenTnc,setDialogOpenTnc,userEmail,updateTermAndConditionAcceptenceFn } = props
    const [isValid, setIsValid] = useState(false);

    const handleSubmit = () => {
        if (!isValid) {
        alert('Please accept the Terms and Conditions');
        } else {
        // proceed with form submission
            const userTncParams = {
                userMail:userEmail,
                isTermAccepted:isValid,
            }
            try {
                updateTermAndConditionAcceptenceFn(userTncParams)
                setDialogOpenTnc(false)
            } catch (error) {
                console.log('First Term & Condition Err:', error)
            }
        }
    };

    // console.log("ShowPopupFirstTime isValid", isValid)
    // console.log("ShowPopupFirstTime  recived", dialogOpenTnc )

    return( 
        <CommonDialog
        open={dialogOpenTnc}
        title="Term And Condition"
        confirmText="Approve"
        cancelText=""
        content={
          <TermsCheckbox onValidationChange={setIsValid} />
        }
        // onClose={() => setDialogOpenTnc(!false)}
        onConfirm={handleSubmit}
        disabled={!isValid}
      />
    )
}

